import React from "react";
import "./App.css";
import StudyAbroadConsultant from "./StudyAbroadConsultant";
import { ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";

function App() {
  return (
    <ConfigProvider
      locale={viVN}
      theme={{
        token: {
          fontFamily: "'Be Vietnam Pro', sans-serif",
          colorPrimary: "#003eb3", // Academic Blue
          colorSuccess: "#52c41a",
          colorWarning: "#faad14",
          borderRadius: 8, // Softer corners
          wireframe: false,
          colorBgLayout: "#f5f7fa",
        },
        components: {
          Card: {
            boxShadowTertiary: "0 4px 20px rgba(0,0,0,0.05)", // Soft shadow
            headerFontSize: 18,
          },
          Button: {
            fontWeight: 500,
            controlHeightLG: 45, // Taller, friendlier buttons
          },
          Input: {
            controlHeight: 40,
            colorBgContainer: "#ffffff",
          },
          Select: {
            controlHeight: 40,
          },
          InputNumber: {
            controlHeight: 40,
          },
        },
      }}
    >
      <StudyAbroadConsultant />
    </ConfigProvider>
  );
}

export default App;
